import {connect} from "react-redux";
import FirstInteractionFIRForm from "./firstInteractionFIRForm";
import {bindActionCreators} from "redux";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

import {
    firAutofill
  } from "services/redux/installation/firForms/action";


const mapStateToProps = (state) => ({
    firData: state.firAutofillData.firData,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  });


    const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        firAutofill,
        documentUploadUrlPublic
      },
      dispatch
    );

export default connect
(mapStateToProps, mapDispatchToProps)
(FirstInteractionFIRForm);
